import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-39d959f0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "editable-price-change-field" }
const _hoisted_2 = { class: "editable-price-change-field__prices" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, "no scheduled price changes", -1))
const _hoisted_5 = [
  _hoisted_4
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_btn = _resolveComponent("q-btn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.scheduledPrices, (price, id) => {
        return (_openBlock(), _createElementBlock("div", { key: id }, _toDisplayString(price.price * 0.01) + " " + _toDisplayString(_ctx.currency) + " - from " + _toDisplayString(_ctx.formatDateString(price.validFrom)), 1))
      }), 128)),
      (!_ctx.scheduledPrices.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_5))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_q_btn, {
      onClick: _ctx.onChangePrices,
      class: "editable-price-change-field__edit-icon",
      color: "grey-7",
      flat: "",
      round: "",
      icon: "mdi-pencil-outline"
    }, null, 8, ["onClick"])
  ]))
}